module.exports = __webpack_public_path__ + "64d56caef36648b9c6d086210e96cc51.svg";